/**
 * Workspace Thunks
 * Async thunk for fetching apps available to the current tenant's workspace.
 *
 * Requirements: 1.2
 */

import { createAsyncThunk } from '@reduxjs/toolkit';
import { sysAppService, SysAppDto } from '../../services/api/sysAppService';

export interface WorkspaceAppsPayload {
  apps: SysAppDto[];
  useCustomWorkspace: boolean;
  /** Tenant-scoped company-name override; null ⇒ use global branding. */
  tenantCompanyName: string | null;
  /** Tenant-resolved page logo URL; null ⇒ render the built-in default logo. */
  tenantLogoUrl: string | null;
  /** Tenant-resolved header-corner icon URL; null ⇒ render the Default Tenant logo. */
  tenantLogoIconUrl: string | null;
}

/**
 * Fetches the list of apps and tools available to the given tenant,
 * plus the workspace.use_custom_view config flag.
 */
export const fetchWorkspaceApps = createAsyncThunk(
  'workspace/fetchWorkspaceApps',
  async (tenantId: number, { rejectWithValue }) => {
    try {
      return await sysAppService.getAvailableAppsWithConfig(tenantId);
    } catch (error: any) {
      return rejectWithValue(error.message ?? 'Failed to fetch workspace apps');
    }
  }
);
